import React from 'react';
import Loading from '../presentational/Loading';

const LoadingContainer = () => {
    return <Loading />;
};

export default LoadingContainer;
